import { GoogleMapProps, GoogleMap } from '@react-google-maps/api';

type GoogleMapType = GoogleMapProps & {
  children?: React.ReactNode;
};

const NORWAY_COORDINATES = {
  lat: 64.5783089,
  lng: 17.888237,
};

export const NORWAY_BOUNDS = {
  south: 58.0930431,
  west: 5.061543,
  north: 70.9820295,
  east: 29.9499028,
};

export const GOOGLE_MAP_PROPS = {
  minzoom: 5,
  midzoom: 10,
  maxzoom: 15,
  center: NORWAY_COORDINATES,
  bounds: NORWAY_BOUNDS,
} as const;

export const CustomGoogleMap = ({ children, ...props }: GoogleMapType) => {
  const renderMap = () => {
    return <GoogleMap {...props}>{children}</GoogleMap>;
  };
  return renderMap();
};
